import React from 'react';
import cls from 'classnames';
import { FormattedMessage } from 'react-intl';

import './Tools.scss';
/**
 * @param {object} props
 * @param {string} props.showStep
 *
 */

function Tool_step({ showStep, mode }) {
  showStep = Number(showStep);
  return (
    <div className="Tool Tool__step d-flex align-items-center">
      <div
        className={cls(
          'Tool__step__Item',
          showStep === 1
            ? 'Tool__step__Item_current'
            : showStep > 1
              ? 'Tool__step__Item_checked'
              : ''
        )}
      >
        <div className="Tool__step__symbol" children={1} />
        <div
          className={cls('Tool__step__stepInfo')}
          children={mode === 'verify' ? (<FormattedMessage id="stepBar.takeOrder.step1" />) :
            (<FormattedMessage id="stepBar.takeOrder.step3" />)}
        />
      </div>
      <div
        className={cls(
          'Tool__step__Item',
          showStep === 2
            ? 'Tool__step__Item_current'
            : showStep > 2
              ? 'Tool__step__Item_checked'
              : ''
        )}
      >
        <div className="Tool__step__symbol" children={2} />
        <div
          className={cls('Tool__step__stepInfo')}
          children={mode === 'verify' ? (<FormattedMessage id="stepBar.takeOrder.step2" />) :
            (<FormattedMessage id="stepBar.takeOrder.step4" />)}
        />
      </div>
      <div
        className={cls(
          'Tool__step__Item',
          showStep === 3
            ? 'Tool__step__Item_current'
            : showStep > 3
              ? 'Tool__step__Item_checked'
              : ''
        )}
      >
        <div className="Tool__step__symbol" children={3} />
        <div
          className={cls('Tool__step__stepInfo')}
          children={mode === 'verify' ? (<FormattedMessage id="stepBar.takeOrder.step3" />) :
            (<FormattedMessage id="stepBar.takeOrder.step5" />)}
        />
      </div>
      {mode === 'verify' ? (
        <>
          <div
            className={cls(
              'Tool__step__Item',
              showStep === 4
                ? 'Tool__step__Item_current'
                : showStep > 4
                  ? 'Tool__step__Item_checked'
                  : ''
            )}
          >
            <div className="Tool__step__symbol" children={4} />
            <div
              className={cls('Tool__step__stepInfo')}
              children={<FormattedMessage id="stepBar.takeOrder.step4" />}
            />
          </div>
          <div
            className={cls(
              'Tool__step__Item',
              showStep === 5
                ? 'Tool__step__Item_current'
                : showStep > 5
                  ? 'Tool__step__Item_checked'
                  : ''
            )}
          >
            <div className="Tool__step__symbol" children={5} />
            <div
              className={cls('Tool__step__stepInfo')}
              children={<FormattedMessage id="stepBar.takeOrder.step5" />}
            />
          </div>
        </>
      ) : null}
    </div>
  );
}
export default Tool_step;
